module.exports = __webpack_public_path__ + "img/trend-icon.b63f0d8d.svg";